import React, {useEffect} from 'react';
import {usePhaseState} from 'funnel-schedule/phase-context';
import SalesIndex from './join';
import track from 'utils/track';

export default function (props) {
  const {
    phases: {
      sales: salesSchedule = {
        phase: 'during',
        salesEnd: ''
      }
    }
  } = usePhaseState();

  useEffect(() => {
    track('Product Viewed', {
      product_id: 'C-HHC',
      sku: 'C-HHC',
      name: 'Healthy Heart',
      variant: salesSchedule.phase != 'during' ? 'hhc' : 'hhc-special',
      value: salesSchedule.phase != 'during' ? 497 : 297,
      currency: 'usd'
    });
  }, [salesSchedule.phase]);

  return (
    <SalesIndex
      ctaOverride={salesSchedule.phase != 'during' ? 'sales497' : 'sales297'}
      videoUrlOverride={
        salesSchedule.phase != 'during'
          ? 'https://www.youtube.com/watch?v=a538-bNh_n4'
          : 'https://www.youtube.com/watch?v=RphPKMRHgWE'
      }
      version="salesSpecial"
    />
  );
}
